import { Product } from "./products";
import blackHatRecos from "./ProductRecommendations/blackHatRecos";
import creamCrewRecos from "./ProductRecommendations/creamCrewRecos";
import greenCrewRecos from "./ProductRecommendations/greenCrewRecos";   
import sageHatRecos from "./ProductRecommendations/sageHatRecos";
import wheatHatRecos from "./ProductRecommendations/wheatHatRecos";
import whiteHatRecos from "./ProductRecommendations/whiteHatRecos";
import socksRecos from "./ProductRecommendations/socksRecos";
import littleGuysRecos from "./ProductRecommendations/littleGuysRecos";
import slowAndSteadyRecos from "./ProductRecommendations/slowAndSteadyRecos";
import startSeeingTurtlesRecos from "./ProductRecommendations/startSeeingTurtlesRecos";
import turtlCrossingPinRecos from "./ProductRecommendations/turtlCrossingPinRecos";
import turtlRescueClubPinRecos from "./ProductRecommendations/turtlRescueClubPinRecos";
import turtlRescueClubRecos from "./ProductRecommendations/turtlRescueClubRecos";
import fiftySixBrewingShirtRecos from "./ProductRecommendations/fiftySixBrewingShirtRecos";
import classicAdultRecos from "./ProductRecommendations/classicAdultRecos";
import classicYouthRecos from "./ProductRecommendations/classicYouthRecos";




const productRecoMap: Map<string, Product[]> = new Map();

productRecoMap.set('prod_RPGHVBvdsSDAPO', wheatHatRecos);
productRecoMap.set('prod_RPGGi55hXAWWs7', sageHatRecos);
productRecoMap.set('prod_RPGAL8SZp7lIM8', blackHatRecos);
productRecoMap.set('prod_RPG79AY9CfAPyn', whiteHatRecos);
productRecoMap.set('prod_ROA0rvO0Q0yXAi', creamCrewRecos);
productRecoMap.set('prod_ROA39UFFrPsUOy', greenCrewRecos);
productRecoMap.set('prod_S0LyP6C3ZFDXUh', socksRecos);
productRecoMap.set('prod_SQFAiKCkrEioME', littleGuysRecos);
productRecoMap.set('prod_SQFBhQegJSKGoB', slowAndSteadyRecos);
productRecoMap.set('prod_SQF9iNXGRxqDtQ', startSeeingTurtlesRecos);
productRecoMap.set('prod_SQF8DhboAjXbAM', turtlRescueClubRecos);
productRecoMap.set('prod_SQFDO1sXhZjIcN', turtlCrossingPinRecos);
productRecoMap.set('prod_SQFE7MB4EuZ5dy', turtlRescueClubPinRecos);

// New 2025 T-shirt line
productRecoMap.set('prod_TP5Qruo46TawO', fiftySixBrewingShirtRecos);
productRecoMap.set('prod_TP4kZGEK1n1xSe', classicAdultRecos);
productRecoMap.set('prod_TP3AwraFmrNFn', classicYouthRecos);

export default productRecoMap;
